export default __webpack_public_path__ + "static/media/Stroke-SouthAcutestrokepathway-SouthYorkshire(inclvideotriage).2cb75213.jpg";